import { render } from "./changePassWord.vue?vue&type=template&id=84e140c8&scoped=true"
import script from "./changePassWord.vue?vue&type=script&lang=js"
export * from "./changePassWord.vue?vue&type=script&lang=js"

import "./changePassWord.vue?vue&type=style&index=0&id=84e140c8&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84e140c8"]])

export default __exports__